// public/js/features/assets/form-config.js
import { escapeHtml } from '../../utils/escape.js';

export const assetBasicFields = [
  { key: 'label', label: 'Label', type: 'text', required: true },
  { key: 'reference', label: 'Reference', type: 'text' },
  { key: 'serial', label: 'Serial', type: 'text' },
  { key: 'type', label: 'Type', type: 'select', options: [
    { value: 'engine-stand', text: 'Engine Stand' },
    { value: 'apu', text: 'APU' },
    { value: 'other', text: 'Other' }
  ] },
  { key: 'status', label: 'Status', type: 'select', options: [
    { value: 'active', text: 'Active' },
    { value: 'inactive', text: 'Inactive' }
  ] },
  { key: 'tenantId', label: 'Tenant', type: 'select', required: false, dynamic: true }   // ← required: false (no asterisk anymore)
];

export function renderBasicFormHTML(fields, values = {}, tenants = []) {
  let html = '';
  fields.forEach(field => {
    const value = values[field.key] || '';
    let input = '';

    if (field.type === 'select') {
      let opts = '';
      if (field.dynamic && tenants.length) {
        let optsList = '';
        if (field.key === 'tenantId') {
          const isUnassigned = !value || value === '' || value === 'unassigned';
          optsList = `<option value="" ${isUnassigned ? 'selected' : ''}>— Unassigned —</option>`;
        }
        optsList += tenants.map(t => `<option value="${escapeHtml(t.tenantId)}" ${value === t.tenantId ? 'selected' : ''}>${escapeHtml(t.name || t.tenantId)}</option>`).join('');
        opts = optsList;
      } else if (field.options) {
        // Tolerate both {value,text} and {value,label}; registry selects are
        // optional, so prepend a blank choice.
        if (field.registry) opts += `<option value="" ${!value ? 'selected' : ''}>— none —</option>`;
        opts += field.options.map(opt => `<option value="${escapeHtml(opt.value)}" ${value === opt.value ? 'selected' : ''}>${escapeHtml(opt.text ?? opt.label ?? opt.value)}</option>`).join('');
      }
      input = `<select id="asset-${field.key}" class="form-select${field.key === 'tenantId' ? ' tenant-blur' : ''}">${opts}</select>`;
    } else {
      input = `<input id="asset-${field.key}" type="text" class="form-control" value="${escapeHtml(value)}" ${field.required ? 'required' : ''}>`;
    }

    html += `
      <div class="mb-3" data-field-row="${field.key}">
        <label class="form-label" data-field-label="${field.key}">${escapeHtml(field.label)}${field.required ? ' <span class="text-danger">*</span>' : ''}</label>
        ${input}
      </div>`;
  });
  return html;
}